import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { PartnerGroups } from '@/models/partnerGroups';
import filterModel from '@/store/partnerGroups/filterModel';
import PartnerGroupsFilter from '@/store/partnerGroups/filterEntity';
import { Filter } from '@/types/filter/filter';
@Module({ dynamic: true, store, name: PartnerGroups.moduleName, namespaced: true })
class PartnerGroupsModule extends PageBaseModule {
    filter: Filter;

    constructor(module: PartnerGroupsModule) {
        super(module);

        const page = new PageEntity();
        page.setModuleName(PartnerGroups.moduleName);
        page.setTitle(PartnerGroups.listTitle);
        page.setTitleAdd(PartnerGroups.createTitle);
        page.setTitleEdit(PartnerGroups.editTitle);
        page.values.actionPagination = 'partnerGroups/updatePage';
        page.values.actionPageAmountItems = 'partnerGroups/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${PartnerGroups.moduleName}_edit`;
        this.pageSettings.routeParam = `${PartnerGroups.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(PartnerGroupsFilter);
        this.filter.setFilterName('PartnerGroupsFilter');
        this.filter.setTemplateClassName('template-lg directory-filters');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(PartnerGroups.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(PartnerGroupsModule);
